<template>
  <div class="tests">
    <h3>{{ $t("common.tests") }}</h3>
    <div v-if="purchasedStore.tests" class="tests__wrap">
      <CourseTest
        v-for="(test, index) in purchasedStore.tests"
        :key="index"
        :test="test"
      />
    </div>
  </div>
</template>
<script>
import CourseTest from "@/components/course/CourseTest";
import { useRoute } from "vue-router";
import { getPurchasedStore } from "@/store/modules/purchased.store";

export default {
  components: {
    CourseTest,
  },
  setup() {
    const route = useRoute();
    const purchasedStore = getPurchasedStore();

    return {
      route,
      purchasedStore,
    };
  },
};
</script>
<style lang="scss" scoped>
.tests {
  margin: 60px 0;

  &__wrap {
    display: flex;
    flex-direction: column;
  }

  h3 {
    color: $color-blue;
    font-family: $font-family;
    font-size: $font-size-lg;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 40px;
  }

  &__item {
    display: flex;
    flex-direction: row;
    gap: 116px;
    border-bottom: 1px solid $color-light-grey;
    padding-top: 40px;
    padding-bottom: 40px;

    @media screen and (max-width: 900px) {
      flex-wrap: wrap;
    }
  }

  &__block {
    flex-basis: 100%;

    &--sidebar {
      flex-basis: 524px;
    }
  }
}
</style>
